import { tv } from '@simplywallst/ui-core/next';

export const styles = tv({
  slots: {
    fieldset: 'tw-reset group/field m-0 flex flex-col gap-x0_75',
    label:
      'tw-reset m-0 text-xs text-solid opacity-70 transition-opacity group-focus-within/field:opacity-100',
    inputEl:
      'tw-reset h-x5 w-full select-none rounded-x0_5 bg-transparent p-x1_75 pe-x5 text-xs text-[--s-field-input-color-text] caret-brand-01 group-data-[prefix=true]/input:ps-x5',
    input: [
      'tw-reset group/input relative h-x5 rounded-x0_5 p-0 text-xs font-normal',
      'border border-solid border-[--s-field-input-color-border]',
      'bg-[--s-field-input-color-bg]',
      'focus-outline opacity-70 transition-opacity',
      'group-focus-within/field:bg-[--s-field-input-focus-color-bg] group-focus-within/field:opacity-100',
      'inline-flex items-center justify-center gap-x0_5',
    ],
    inputPrefix: [
      'pointer-events-none absolute start-x1_25 flex items-center',
      'fill-[--s-field-input-color-text] opacity-70 transition-opacity',
      'text-[--s-field-input-color-text]',
    ],
    error:
      'mt-[-2px] text-tiny text-solid opacity-60 transition-opacity group-focus-within/field:opacity-80 light:opacity-90 light:group-focus-within/field:opacity-100',
  },
  variants: {
    isDisabled: {
      true: {
        label: 'opacity-30',
        inputEl: 'pointer-events-none',
        input: 'opacity-30',
      },
    },
    hasError: {
      true: {
        input: 'border-[--s-field-input-error-color-border]',
        error: 'text-[--s-field-input-error-color-text]',
      },
    },
  },
  defaultVariants: {
    isDisabled: false,
  },
});
